import { type } from '../constants/manageNumbersConstant'
import { NumberSubscriptionStatusReducer, NumberSubscriptionSubStatusReducer, DocTypeMappingReducer, DocResubmitReducer } from '../models/manageNumbers.interface';

const initialState: NumberSubscriptionStatusReducer = {
    numberSubscriptionStatusLoading: false,
    numberSubscriptionStatusData: {},
    numberSubscriptionStatusError: false,
    numberSubscriptionStatusErrorMsg: '',
}

export const numberSubscriptionStatusReducer = (state: NumberSubscriptionStatusReducer = initialState, action: any): NumberSubscriptionStatusReducer => {

    switch (action.type) {
        case type.SUBSCRIPTION_STATUS_LOADING:
            return {
                ...state,
                numberSubscriptionStatusLoading: true,
                numberSubscriptionStatusError: false
            }
        case type.SUBSCRIPTION_STATUS_SUCCESS:
            return {
                ...state,
                numberSubscriptionStatusLoading: false,
                numberSubscriptionStatusError: false,
                numberSubscriptionStatusData: action.payload.res.data,
            }
        case type.SUBSCRIPTION_STATUS_FAILED:
            return {
                ...state,
                numberSubscriptionStatusLoading: false,
                numberSubscriptionStatusError: true,
                numberSubscriptionStatusErrorMsg: action.payload.error
            }
        default:
            return state;
    }
}


const initialSubState: NumberSubscriptionSubStatusReducer = {
    numberSubscriptionSubStatusLoading: false,
    numberSubscriptionSubStatusData: {},
    numberSubscriptionSubStatusError: false,
    numberSubscriptionSubStatusErrorMsg: '',
}

export const numberSubscriptionSubStatusReducer = (state: NumberSubscriptionSubStatusReducer = initialSubState, action: any): NumberSubscriptionSubStatusReducer => {

    switch (action.type) {
        case type.SUBSCRIPTION_SUB_STATUS_LOADING:
            return {
                ...state,
                numberSubscriptionSubStatusLoading: true,
                numberSubscriptionSubStatusError: false
            }
        case type.SUBSCRIPTION_SUB_STATUS_SUCCESS:
            return {
                ...state,
                numberSubscriptionSubStatusLoading: false,
                numberSubscriptionSubStatusError: false,
                numberSubscriptionSubStatusData: action.payload.res.data,
            }
        case type.SUBSCRIPTION_SUB_STATUS_FAILED:
            return {
                ...state,
                numberSubscriptionSubStatusLoading: false,
                numberSubscriptionSubStatusError: true,
                numberSubscriptionSubStatusErrorMsg: action.payload.error
            }
        default:
            return state;
    }
}


const initialDocMapping: DocTypeMappingReducer = {
    docTypeMappingLoading: false,
    docTypeMappingData: {},
    docTypeMappingError: false,
    docTypeMappingErrorMsg: '',
}

export const docTypeMappingReducer = (state: DocTypeMappingReducer = initialDocMapping, action: any): DocTypeMappingReducer => {

    switch (action.type) {
        case type.DOC_TYPE_MAPPING_LOADING:
            return {
                ...state,
                docTypeMappingLoading: true,
                docTypeMappingError: false
            }
        case type.DOC_TYPE_MAPPING_SUCCESS:
            return {
                ...state,
                docTypeMappingLoading: false,
                docTypeMappingError: false,
                docTypeMappingData: action.payload.res.data,
            }
        case type.DOC_TYPE_MAPPING_FAILED:
            return {
                ...state,
                docTypeMappingLoading: false,
                docTypeMappingError: true,
                docTypeMappingErrorMsg: action.payload.error
            }
        default:
            return state;
    }
}



const docResubmitState: DocResubmitReducer = {
    docResubmitLoading: false,
    docResubmitData: [],
    docResubmitError: false,
    docResubmitErrorMsg: '',
}

export const docResubmitReducer = (state: DocResubmitReducer = docResubmitState, action: any): DocResubmitReducer => {

    switch (action.type) {
        case type.DOC_RESUBMIT_INIT:
            return {
                ...state,
                docResubmitLoading: true,
                docResubmitError: false
            }
        case type.DOC_RESUBMIT_SUCCESS:
            return {
                ...state,
                docResubmitLoading: false,
                docResubmitError: false,
                docResubmitData: action.payload.res.data,
            }
        case type.DOC_RESUBMIT_FAILED:
            return {
                ...state,
                docResubmitLoading: false,
                docResubmitError: true,
                docResubmitErrorMsg: action.payload.error
            }
        default:
            return state;
    }
}

